import type { ComputedRef } from 'vue'
import { useAuthStore } from '~/stores/auth'
import { PORTAL_LEADERS_LOUNGE } from '~/utils/portalRoutes'
import { COMMUNITY_JOIN_STAMPIN_UP, COMMUNITY_STAMPIN_REWARDS } from '~/utils/communityRoutes'

export interface HeaderTopLinkDescriptor {
  id: 'rewards' | 'join' | 'blog' | 'leaders-lounge' | 'reports' | 'policies'
  label: string
  to: string
  // Mobile keeps its existing external-http-slug convention.
  external: boolean
}

// Visible auxiliary links; each surface owns its rendering/adaptation.
export const useHeaderTopLinks = (): ComputedRef<HeaderTopLinkDescriptor[]> => {
  const { t } = useI18n()
  const authStore = useAuthStore()
  const { isDemo } = useSAuthState()
  const { blogUrl } = useBlogUrl()
  const { reportsUrl } = useReportsUrl()
  const { policiesUrl } = usePoliciesUrl()

  return computed<HeaderTopLinkDescriptor[]>(() => {
    if (isDemo.value) {
      const links: HeaderTopLinkDescriptor[] = []
      if (authStore.isSilverEliteOrAbove) {
        links.push({ id: 'leaders-lounge', label: t('menu.leaders-lounge'), to: PORTAL_LEADERS_LOUNGE, external: false })
      }
      links.push(
        { id: 'reports', label: t('link.viewMyReports'), to: reportsUrl.value, external: true },
        { id: 'policies', label: t('link.policies'), to: policiesUrl.value, external: true }
      )
      return links
    }

    return [
      { id: 'rewards', label: t('label.rewards'), to: COMMUNITY_STAMPIN_REWARDS, external: false },
      { id: 'join', label: t('input.btn.join'), to: COMMUNITY_JOIN_STAMPIN_UP, external: false },
      { id: 'blog', label: t('input.btn.blog'), to: blogUrl.value, external: true }
    ]
  })
}
